import React, { useState, useEffect } from "react";
import styled from "styled-components";
import ErrorIcon from "assets/icons/icon-error.webp";
import { Button } from "components";
import colors from "assets/styles/color";
import { getEnvConfig } from "services/apis";
import { hideLoading, showLoading } from "features/loading/loadingSlice";
import { useDispatch } from "react-redux";

const LeaveConfirm = ({ modalClose, onConfirm }) => {
  const dispatch = useDispatch();
  const [resignDays, setResignDays] = useState(30);

  useEffect(() => {
    dispatch(showLoading());
    getEnvConfig("USER_RESIGNUP_DAYS")
      .then(({ data: { success, data } }) => {
        success && setResignDays(data?.value);
      })
      .finally(() => dispatch(hideLoading()));
  }, []);

  return (
    <>
      <MarkIcon src={ErrorIcon} alt="icon" />
      <MainTitle>정말 탈퇴하시겠습니까?</MainTitle>
      <SubText>{`탈퇴 후 ${resignDays}일간 가입할 수 없습니다.`}</SubText>
      <ButtonWrapper>
        <Button
          text="취소"
          size="sm"
          variant="round"
          disabled="modal"
          onClickFn={() => modalClose()}
        />
        <Button
          text="탈퇴하기"
          size="sm"
          variant="round"
          onClickFn={() => onConfirm()}
        />
      </ButtonWrapper>
    </>
  );
};

export default LeaveConfirm;
const MarkIcon = styled.img`
  width: 48px;
  height: 48px;

  margin-top: 16px;
  margin-bottom: 24px;
`;

const MainTitle = styled.div`
  color: ${colors.black200};
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.36px;
  line-height: 28px;
  text-align: center;
  white-space: pre-line;

  margin-bottom: 13px;
`;

const SubText = styled.div`
  font-size: 15px;
  font-weight: 400;
  color: ${colors.black600};
  line-height: 24.5px;
  letter-spacing: -0.3px;
  text-align: center;
  padding: 0 18px;
  margin-bottom: 32px;
  white-space: pre-line;
`;

const ButtonWrapper = styled.div`
  width: 100%;
  ${({ theme }) => theme.flexBox("row", "flex-end", "center")};

  /* 첫 버튼 margin 나누기 */
  button:first-child {
    margin-right: 8px;
  }
  /* 동의 버튼 font-weight 굵게 */
  button:last-child {
    font-weight: 700;
  }
`;
